import React from 'react'
import PropTypes from 'prop-types'
import {
  AddGoalButton,
  Error,
  ErrorText,
  GoalTextLabel,
  HeaderWrapper,
  InputLabel,
  OptionalGoalsContainer,
  OptionalGoalWrapper,
  RemoveGoalLink,
  StyledHr,
  StyledTextAreaWithCharacterCounter,
  StyledWarningIcon,
} from './component.styles'
import { StyledCalendarInput } from '../AddGoals/component.styles'
import { AddIcon } from 'secondstep-components'
import { additionalGoalFields } from '../data'

const OptionalGoals = ({
  additionalGoalCount,
  values,
  errors,
  touched,
  handleChange,
  handleChangeGoalCount,
}) => {
  return (
    <OptionalGoalsContainer>
      {additionalGoalFields.map((goalField, index) => {
        const shouldShowGoal = index < additionalGoalCount
        return (
          shouldShowGoal && (
            <OptionalGoalWrapper key={goalField.text}>
              <HeaderWrapper>
                <GoalTextLabel>Goal {index + 3}</GoalTextLabel>
                <RemoveGoalLink
                  dataTestId="remove-goal-link"
                  onClick={() => handleChangeGoalCount(-1, index)}
                >
                  Remove
                </RemoveGoalLink>
              </HeaderWrapper>
              <StyledHr />
              <InputLabel>Custom Goal</InputLabel>
              <StyledTextAreaWithCharacterCounter
                error={touched[goalField.text] && errors[goalField.text]}
                name={`goal${index + 3}Text`}
                onChange={e => handleChange(goalField.text, e.target.value)}
                value={values[goalField.text] || ''}
              />
              <InputLabel>Target Date</InputLabel>
              <StyledCalendarInput
                date={values[goalField.date]}
                handleChange={handleChange}
                hasError={!!errors[goalField.date] && !!touched[goalField.date]}
                name={goalField.date}
              />
              {errors[goalField.date] && touched[goalField.date] && (
                <Error>
                  <StyledWarningIcon />
                  <ErrorText>{errors[goalField.date]}</ErrorText>
                </Error>
              )}
            </OptionalGoalWrapper>
          )
        )
      })}

      {additionalGoalCount < 3 && (
        <AddGoalButton onClick={() => handleChangeGoalCount(1)}>
          <AddIcon />
          Add an optional goal
        </AddGoalButton>
      )}
    </OptionalGoalsContainer>
  )
}

OptionalGoals.propTypes = {
  additionalGoalCount: PropTypes.number.isRequired,
  errors: PropTypes.object,
  handleChange: PropTypes.func.isRequired,
  handleChangeGoalCount: PropTypes.func.isRequired,
  touched: PropTypes.object,
  values: PropTypes.object,
}

export default OptionalGoals
